import { ChangeDetectionStrategy, Component } from "@angular/core";

import {
  ITab,
  TabNavigationComponent,
  TabNavigationStateService,
  tabNavigationStateServiceInjectionToken
} from "@zaeper/angular-dashboard-view-lib";
import { ZTemplateDirective } from "@zaeper/angular-core-lib";
import { LoginAttemptsTabComponent } from "./tabs/login-attempts-tab/login-attempts-tab.component";

@Component({
  selector: "app-activities-tab",
  templateUrl: "./activities-tab.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TabNavigationComponent,
    ZTemplateDirective,
    LoginAttemptsTabComponent
],
  providers: [
    {
      provide: tabNavigationStateServiceInjectionToken,
      useClass: TabNavigationStateService
    }
  ]
})
export class ActivitiesTabComponent {
  public tabs: ITab[] = [
    {
      title: "Anmeldungen",
      subject: "logins"
    }
  ];
}
